import { FloorPlanInfo } from '../FloorPlanInfo';
import { PageRow } from '../PageRow';
import { DataSummary } from '../common/DataSummary';
import type { FloorPlanPreviewProps } from './types';

export const FloorPlanPreview = ({
  countsData,
  routesData,
  pageSettingsMap,
  onPageSettingsChange,
  planName,
  onPlanNameChange,
  projectId,
}: FloorPlanPreviewProps) => {
  const pages = countsData.pages || [];
  const groupCount = countsData.groups?.length || 0;
  const markerCount = (countsData.groups || []).reduce(
    (sum, g) => sum + (g.markers?.length || 0),
    0,
  );
  const routeCount = routesData?.routes?.length || 0;
  const cableTypes = routesData
    ? new Set(routesData.routes?.map((r) => r.cable_type || '')).size
    : 0;

  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Preview — What Will Be Imported
      </h2>

      <FloorPlanInfo
        planName={planName}
        onPlanNameChange={onPlanNameChange}
      />

      <div className="bg-[#0d1117] border border-[#30363d] rounded-md p-3 mb-3">
        <h3 className="text-sm text-[#c9d1d9] font-semibold mb-2">Pages</h3>
        {pages.length === 0 ? (
          <div className="text-[12px] text-[#d29922]">
            No pages found in counts JSON
          </div>
        ) : (
          pages.map((p) => (
            <PageRow
              key={p.index}
              page={p}
              projectId={projectId}
              planName={planName}
              settings={
                pageSettingsMap[p.index] || {
                  scaleFactor: 1,
                  quality: 85,
                  outputFormat: 'webp' as const,
                  file: null,
                  naturalWidth: null,
                  naturalHeight: null,
                }
              }
              onChange={(update) => onPageSettingsChange(p.index, update)}
            />
          ))
        )}
      </div>

      <div className="bg-[#0d1117] border border-[#30363d] rounded-md p-3">
        <h3 className="text-sm text-[#c9d1d9] font-semibold mb-2">
          Data Summary
        </h3>
        <DataSummary
          items={[
            { label: `${pages.length} page(s)`, variant: 'green' },
            { label: `${groupCount} element group(s)`, variant: 'green' },
            { label: `${markerCount} marker(s)`, variant: 'green' },
            {
              label: `${routeCount} route(s)`,
              variant: routesData ? 'green' : 'default',
            },
            {
              label: `${cableTypes} cable type(s)`,
              variant: routesData ? 'green' : 'default',
            },
          ]}
        />
      </div>
    </div>
  );
};
